module.exports = __webpack_public_path__ + "img/wallet.6d4d3fd9.svg";